import { useState } from 'react'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import { CvsAutoComplete } from '@components'
import { RequiredTextField } from '../components/required-text-field'
import { t } from '@lingui/core/macro'

export const DateSeg = ({ segment, updateSegment }) => {
  const [updatedSegment, setUpdatedSegment] = useState({ ...segment })

  const onUpdate = () => {
    updateSegment(updatedSegment)
  }

  return (
    <div style={{ padding: 12, paddingTop: 24 }}>
      <div>
        <RequiredTextField value={updatedSegment} onChange={setUpdatedSegment} label={t`Name`} />
      </div>
      <div style={{ marginTop: 8 }}>
        <CvsAutoComplete
          style={{ width: '100%', margin: 0 }}
          label={t`Order`}
          options={[
            { value: 'months-days-years', label: 'M|D|Y' },
            { value: 'months-years-days', label: 'M|Y|D' },
            { value: 'years-days-months', label: 'Y|D|M' },
            { value: 'days-months-years', label: 'D|M|Y' },
            { value: 'years-months-days', label: 'Y|M|D' },
          ]}
          selected={updatedSegment.date.order}
          onSelected={item => {
            setUpdatedSegment({
              ...updatedSegment,
              date: { ...updatedSegment.date, order: item },
            })
          }}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <CvsAutoComplete
          style={{ width: '100%', margin: 0 }}
          label={t`Month format`}
          options={[
            { value: '1-12', label: '1-12' },
            { value: '01-12', label: '01-12' },
            { value: 'Jan-Dec', label: 'Jan-Dec' },
            { value: 'January-December', label: 'January-December' },
            { value: 'None', label: 'None' },
          ]}
          selected={updatedSegment.date.months}
          onSelected={item => {
            setUpdatedSegment({
              ...updatedSegment,
              date: { ...updatedSegment.date, months: item },
            })
          }}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <CvsAutoComplete
          style={{ width: '100%', margin: 0 }}
          label={t`Day format`}
          options={[
            { value: '1-31', label: '1-31' },
            { value: '01-31', label: '01-31' },
            { value: 'None', label: 'None' },
          ]}
          selected={updatedSegment.date.days}
          onSelected={item => {
            setUpdatedSegment({
              ...updatedSegment,
              date: { ...updatedSegment.date, days: item },
            })
          }}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <CvsAutoComplete
          style={{ width: '100%', margin: 0 }}
          label={t`Year format`}
          options={[
            { value: '00-99', label: '00-99' },
            { value: '0000-9999', label: '0000-9999' },
            { value: 'None', label: 'None' },
          ]}
          selected={updatedSegment.date.years}
          onSelected={item => {
            setUpdatedSegment({
              ...updatedSegment,
              date: { ...updatedSegment.date, years: item },
            })
          }}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <TextField
          variant="outlined"
          style={{ width: '100%' }}
          label={t`Separator`}
          value={updatedSegment.delimiter}
          onChange={e => {
            setUpdatedSegment({ ...updatedSegment, delimiter: e.target.value })
          }}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <FormControlLabel
          style={{ margin: 0, height: 70 }}
          control={
            <Checkbox
              checked={updatedSegment.date.auto_populate}
              onChange={(e, newVal) => {
                setUpdatedSegment({
                  ...updatedSegment,
                  date: { ...updatedSegment.date, auto_populate: newVal },
                })
              }}
              value={updatedSegment.date.auto_populate}
              style={{ padding: 2 }}
              color="secondary"
            />
          }
          label={t`Auto populate date upon submission`}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={onUpdate}
          style={{ width: '100%' }}
          disabled={!updatedSegment.name}
        >
          {t`Done`}
        </Button>
      </div>
    </div>
  )
}
